<template>
  <div>
    <div class="text-center">
      <div style="color: #dadada; margin-top: 70px; font-size: 40px">
        <span>ไม่พบข้อมูล</span>
        <div>
          <v-icon style="color: #dadada; font-size: 70px" class="mt-9"
            >mdi-text-box-search-outline</v-icon
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>